/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow } from "@mui/material";
import React from "react";
// import GhostTable from "../../../../components/common/new/GhostTable/GhostTable";
import NewGhostTable from "../../../../components/common/new/GhostTable/NewGhostTable";
import Typography from "../../../../components/common/new/Typography/Typography";
import styles, { tabelCellWidth } from "../AppointmentSubmission.styles";
import AddPlusIcon from "../../../../assets/svg/addPlusIcon";
import useUserConfig from "../../../../hooks/useUserConfig";
import { PERMISSIONS } from "../../../../contants";

const COLS = [
  {
    displayName: "RELATION",
    key: "relation",
  },
  {
    displayName: "RELATED MEMBER",
    key: "relatedMember",
  },
  {
    displayName: "RELATED MEMBER AGE",
    key: "relatedMemberAge",
  },
  {
    displayName: "REMARKS",
    key: "remarks",
  },
];

const EXISTING_COLS = [
  { displayName: "Member", key: "member" },
  { displayName: "", key: "is" }, // ← new
  { displayName: "RELATION", key: "relation" },
  { displayName: "", key: "of" }, // ← new
  { displayName: "RELATED MEMBER", key: "relatedMember" },
];

const getRows = (combinedData) =>
  combinedData?.map((memberData) => {
    return (
      <TableRow py="16px 16px 16px 0px">
        <TableCell
          width="20%"
          style={{
            ...styles.greyTableCell,
            ...tabelCellWidth.medium,
          }}
        >
          <Typography variant="small" color="#183053">
            {memberData.relationType || "NA"}
          </Typography>
        </TableCell>
        <TableCell
          width="20%"
          style={{
            ...styles.greyTableCell,
            ...tabelCellWidth.medium,
          }}
        >
          <Typography variant="small" color="#183053">
            {memberData?.name || "NA"}
          </Typography>
        </TableCell>
        <TableCell
          width="20%"
          style={{
            ...styles.greyTableCell,
            ...tabelCellWidth.medium,
          }}
        >
          <Typography variant="small" color="#183053">
            {memberData?.age || "NA"}
          </Typography>
        </TableCell>
        <TableCell
          width="20%"
          style={{
            ...styles.greyTableCell,
            ...tabelCellWidth.medium,
          }}
        >
          <Typography variant="small" color="#183053">
            {memberData?.remarks || "NA"}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });

const getExistingFamilyRows = (familyMember) =>
  familyMember?.map((memberData) => {
    // const birthDate = new Date(memberData?.dateOfBirth);
    // const currentDate = new Date();
    // const age =
    //   currentDate.getFullYear() -
    //   birthDate.getFullYear() -
    //   (currentDate.getMonth() < birthDate.getMonth() ||
    //   (currentDate.getMonth() === birthDate.getMonth() &&
    //     currentDate.getDate() < birthDate.getDate())
    //     ? 1
    //     : 0);
    console.log("familyMember", familyMember);
    return (
      // <TableRow py="16px 16px 16px 0px">
      //   <TableCell
      //     width="20%"
      //     style={{
      //       ...styles.greyTableCell,
      //       ...tabelCellWidth.medium,
      //     }}
      //   >
      //     <Typography variant="small" color="#183053">
      //       {memberData?.relationType || "NA"}
      //     </Typography>
      //   </TableCell>
      //   <TableCell
      //     width="20%"
      //     style={{
      //       ...styles.greyTableCell,
      //       ...tabelCellWidth.medium,
      //     }}
      //   >
      //     <Typography variant="small" color="#183053">
      //       {memberData?.member?.fullName || "NA"}
      //     </Typography>
      //   </TableCell>
      //   <TableCell
      //     width="20%"
      //     style={{
      //       ...styles.greyTableCell,
      //       ...tabelCellWidth.medium,
      //     }}
      //   >
      //     <Typography variant="small" color="#183053">
      //       {memberData?.member?.age || age || "NA"}
      //     </Typography>
      //   </TableCell>
      //   <TableCell
      //     width="20%"
      //     style={{
      //       ...styles.greyTableCell,
      //       ...tabelCellWidth.medium,
      //     }}
      //   >
      //     <Typography variant="small" color="#183053">
      //       {memberData?.member?.remark || "NA"}
      //     </Typography>
      //   </TableCell>
      // </TableRow>
      <TableRow style={styles.tableRow}>
        <TableCell width="35%" style={styles.memberItem}>
          <Typography variant="small" color="#183053">
            {memberData?.member?.fullName} ({memberData?.member?.memberId})
          </Typography>
        </TableCell>

        <TableCell
          width="5%"
          style={{ ...styles.memberItem, textAlign: "center" }}
        >
          <Typography variant="small" color="#888">
            IS
          </Typography>
        </TableCell>

        <TableCell
          width="15%"
          style={{ ...styles.memberItem, textAlign: "center" }}
        >
          <Typography variant="small" color="#183053">
            {memberData?.relationType || "NA"}
          </Typography>
        </TableCell>

        <TableCell
          width="5%"
          style={{ ...styles.memberItem, textAlign: "center" }}
        >
          <Typography variant="small" color="#888">
            OF
          </Typography>
        </TableCell>

        <TableCell width="40%" style={styles.memberItem}>
          <Typography variant="small" color="#183053">
            {memberData?.relatedMember?.fullName ?? "NA"} (
            {memberData?.relatedMember?.memberId ?? "NA"})
          </Typography>
        </TableCell>
      </TableRow>
    );
  });

function MemberRelationship({
  memberRelationship,
  showAddLink,
  onAddMember,
  familyMember,
  relationData,
  onAddFamilyMember,
  onCreateFamily,
  // isDistrictSi,
  // isChapterSi,
  // memberInfo,
}) {
  const combinedData = [...(relationData || []), ...(memberRelationship || [])];
  const hasPermission = useUserConfig();

  // const memberViewId = memberInfo.memberId;

  // const handleRemoveItem = () => {
  //   const familyMembersContent = familyMember || [];
  //   const updatedItems = familyMembersContent?.filter(
  //     (item) => item.member.memberId !== memberViewId
  //   );

  //   return updatedItems;
  // };

  // const updatedFamilyMember = handleRemoveItem();

  return (
    <>
      {/* <Box py="16px" width="60%" display="flex" justifyContent="space-between">
        <Typography variant="mini" color="#5e5e5e" weight={600}>
          FAMILY MEMBERS (RESIDING AT SAME ADDRESS)
        </Typography>
      </Box> */}
      <Box>
        <Box py="16px">
          <Box
            style={{
              borderRadius: "35px",
              background: "#196AAB",
              width: "245px",
              height: "44px",
              flexShrink: "0",
              marginBottom: "-30px",
              position: "relative",
              zIndex: "10",
              marginLeft: "45px",
            }}
          >
            <Typography
              variant="title3"
              style={{
                color: "#FFF",
                fontFeatureSettings: "'clig' off, 'liga' off",
                fontFamily: "'Inter', sans-serif",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "20px",
                padding: "11px 18px 13px 17px",
                margin: "0",
              }}
            >
              Practicing Member
            </Typography>
          </Box>
        </Box>
        <Box
          style={{
            borderRadius: "5px 5px 5px 5px",
            border: "1px solid #C2D4EB",
            background: "rgb(246, 246, 246)",
            padding: "0px 0px 20px 20px",
            borderBottom: "9px solid #196AAB",
            margin: "0px 20px",
          }}
        >
          <Box
            sx={{
              margin: "20px",
              marginRight: "40px",
              // marginBottom: "20px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                color: "#484848",

                fontFeatureSettings: "'clig' off, 'liga' off",
                fontFamily: "'Inter', sans-serif",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "20px",
              }}
            >
              Family Members (Residing at Same Address)
            </Typography>
            {hasPermission(PERMISSIONS.CREATE_NEW_FAMILY) && showAddLink && (
              <Box>
                {familyMember?.length ? (
                  <>
                    <AddPlusIcon />
                    <Typography
                      style={{
                        color: "#00ADF8",
                        fontFeatureSettings: "'clig' off, 'liga' off",
                        fontFamily: "'Inter', sans-serif",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: "600",
                        lineHeight: "20px",
                        textDecorationLine: "underline",
                      }}
                      pointer
                      onClick={onAddFamilyMember}
                    >
                      Add member to Family
                    </Typography>
                  </>
                ) : (
                  <>
                    <AddPlusIcon style={{ height: "13px" }} />
                    <Typography
                      style={{
                        color: "#00ADF8",
                        fontFeatureSettings: "'clig' off, 'liga' off",
                        fontFamily: "'Inter', sans-serif",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: "600",
                        lineHeight: "20px",
                        textDecorationLine: "underline",
                      }}
                      pointer
                      onClick={onCreateFamily}
                    >
                      Create Family
                    </Typography>
                  </>
                )}
              </Box>
            )}
          </Box>
          {familyMember?.length ? (
            <div style={{ marginBottom: "20px" }}>
              <NewGhostTable
                columns={EXISTING_COLS}
                rows={getExistingFamilyRows(familyMember)}
              />
            </div>
          ) : (
            <Typography
              component="p"
              align="center"
              variant="mini"
              weight={600}
              my={7}
            >
              No Members
            </Typography>
          )}
        </Box>
      </Box>
      <Box>
        <Box py="16px">
          <Box
            style={{
              borderRadius: "35px",
              background: "#196AAB",
              width: "245px",
              height: "44px",
              flexShrink: "0",
              marginBottom: "-30px",
              position: "relative",
              zIndex: "1",
              marginLeft: "45px",
            }}
          >
            <Typography
              variant="title3"
              style={{
                color: "#FFF",
                fontFeatureSettings: "'clig' off, 'liga' off",
                fontFamily: "'Inter', sans-serif",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "20px",
                padding: "11px 18px 13px 17px",
                margin: "0",
              }}
            >
              Non Practicing Member
            </Typography>
          </Box>
        </Box>
        <Box
          style={{
            borderRadius: "5px 5px 5px 5px",
            border: "1px solid #C2D4EB",
            background: "rgb(246, 246, 246)",
            padding: "0px 0px 20px 20px",
            borderBottom: "9px solid #196AAB",
            margin: "0px 20px",
          }}
        >
          <Box
            style={{
              display: "flex",
              justifyContent: "end",
              margin: "10px 40px 0px 0px",
            }}
          >
            {showAddLink && (
              <>
                <AddPlusIcon />
                <Typography
                  style={{
                    color: "#00ADF8",
                    fontFeatureSettings: "'clig' off, 'liga' off",
                    fontFamily: "'Inter', sans-serif",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "20px",
                    textDecorationLine: "underline",
                  }}
                  pointer
                  onClick={onAddMember}
                >
                  Add non practicing member
                </Typography>
              </>
            )}
          </Box>
          {combinedData?.length ? (
            <div style={{ marginBottom: "20px", marginTop: "20px" }}>
              <NewGhostTable columns={COLS} rows={getRows(combinedData)} />
            </div>
          ) : (
            <Typography
              component="p"
              align="center"
              variant="mini"
              weight={600}
              my={7}
            >
              No Members
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
}

export default MemberRelationship;
